export const doc_artists_es = {
  title: "Artistas",
  description: `Cada álbum tiene un artista, es el único atributo requerido aparte del nombre del álbum.

  Usá al artista para representar bandas, solistas, colaboraciones, o cualquier cosa intermedia.  
  
`
};
